import type { ServiceCode } from '@common/enums';

export enum ServicePermissionsAuthorizations {
    canAddAssets = 'canAddAssets',
    canStart = 'canStart',
}
export type ServicePermissions = { [K in ServiceCode]?: { [T in ServicePermissionsAuthorizations]?: boolean } };
